import * as types from '../types';
import initialState from './initialState';

export default function createdAccountRecurrenceReducer(state = initialState.createdAccountRecurrence, action) {
  switch (action.type) {
    case types.CREATE_ACCOUNT_RECURRENCE_FULFILLED: {
      return action.payload.data;
    }
    case types.CLEAR_CREATED_ACCOUNT_RECURRENCE: {
      return null;
    }
    default:
      return state;
  }
}
